// Actions
import { editEvent as editEventAction } from 'app/shared/eventsOld/actions';

// Utils
import { put } from 'app/shared/utils/fetchr';
import routes from 'app/shared/utils/routes';

export const editEvent = (
  request: ReturnType<typeof editEventAction>['payload'],
) => {
  const { eventId, ...details } = request;
  const path = routes.patronus.eventsEventId.replace(
    ':eventId',
    String(eventId),
  );
  return put(path, details);
};
